namespace Ir.Components.FormattingRules.Popover {
    export interface IFormattingRulePopover {
        show($target, onSelect: (formattingRule: FormattingRule) => void);
    }

    interface IViewModel {
        popoverOptions: DevExpress.ui.dxPopover.Properties;
        formattingRules: any;
        gaugeClick: any;
    }

    interface IParams {
        callback(component: IFormattingRulePopover);
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;

        let onSelectFormattingRule: (formattingRule: FormattingRule) => void;

        this.formattingRules = ko.observableArray();

        let popoverComponent: DevExpress.ui.dxPopover;

        this.popoverOptions = {
            position: "right",
            height: 500,
            width: 300,
            title: "Formatting Rules List",
            onShowing: function (e) {
                self.formattingRules([]);
                self.formattingRules(FormattingRuleService.formattingRules.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                }));
            },
            onInitialized(e) {
                popoverComponent = e.component;
                if (params.callback) {
                    params.callback({
                        show($target, onSelect: (formattingRule: FormattingRule) => void) {
                            onSelectFormattingRule = onSelect;
                            popoverComponent.show($target);
                        },
                    } as IFormattingRulePopover);
                }
            },
        };

        this.gaugeClick = function (formattingRule) {
            if (onSelectFormattingRule)
                onSelectFormattingRule(formattingRule);

            popoverComponent.hide();
        }
    }
}